var map = {
	"./general/DocsIcon--bluecheckmark.svg": 1585,
	"./general/DocsIcon--country.svg": 1586,
	"./general/DocsIcon--github.svg": 1587,
	"./general/DocsIcon--guide.svg": 1588,
	"./general/DocsIcon--list.svg": 1589,
	"./general/DocsIcon--locale.svg": 1590,
	"./general/DocsIcon--thumbsdown.svg": 1591,
	"./general/DocsIcon--thumbsup.svg": 1592,
	"./general/DocsIcon--video.svg": 1593,
	"./nav/DocsIcon--account.svg": 1594,
	"./nav/DocsIcon--business.svg": 1595,
	"./nav/DocsIcon--developertools.svg": 1596,
	"./nav/DocsIcon--financialservices.svg": 1597,
	"./nav/DocsIcon--home.svg": 1598,
	"./nav/DocsIcon--mobilenav.svg": 1599,
	"./nav/DocsIcon--payments.svg": 1600,
	"./nav/DocsIcon--reference.svg": 1601,
	"./nav/DocsIcon--security.svg": 1602,
	"./product/DocsIcon--account.svg": 1603,
	"./product/DocsIcon--atlas.svg": 1604,
	"./product/DocsIcon--capital.svg": 1605,
	"./product/DocsIcon--checkout.svg": 1606,
	"./product/DocsIcon--climate.svg": 1607,
	"./product/DocsIcon--connect.svg": 1608,
	"./product/DocsIcon--corporatecard.svg": 1609,
	"./product/DocsIcon--dashboard.svg": 1610,
	"./product/DocsIcon--developertools.svg": 1611,
	"./product/DocsIcon--elements.svg": 1612,
	"./product/DocsIcon--gateddocs.svg": 1613,
	"./product/DocsIcon--identity.svg": 1614,
	"./product/DocsIcon--implementationguides.svg": 1615,
	"./product/DocsIcon--invoicing.svg": 1616,
	"./product/DocsIcon--issuing.svg": 1617,
	"./product/DocsIcon--partners.svg": 1618,
	"./product/DocsIcon--payments.svg": 1619,
	"./product/DocsIcon--radar.svg": 1620,
	"./product/DocsIcon--reporting.svg": 1621,
	"./product/DocsIcon--sigma.svg": 1622,
	"./product/DocsIcon--styleguide.svg": 1623,
	"./product/DocsIcon--tax.svg": 1624,
	"./product/DocsIcon--terminal.svg": 1625,
	"./product/DocsIcon--treasury.svg": 1626
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1584;